var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyPentugramHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_156_4153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11C2.5 5.75329 6.75329 1.5 12 1.5H48C53.2467 1.5 57.5 5.75329 57.5 11V47C57.5 52.2467 53.2467 56.5 48 56.5H12C6.75329 56.5 2.5 52.2467 2.5 47V11Z",
    stroke: "#F3F3F6",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7476 29.8101V41.4439C41.7476 42.3869 41.3711 43.2914 40.7005 43.9583C40.03 44.6253 39.1204 44.9999 38.172 44.9999H21.827C20.8786 44.9999 19.969 44.6253 19.2985 43.9583C18.6279 43.2914 18.2515 42.3869 18.2515 41.4439V29.8101",
    stroke: "#3070CC",
    strokeWidth: 3.40419,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9097 26.0354L29.9999 13L46.0901 26.0354",
    stroke: "#3070CC",
    strokeWidth: 3.40419,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 32.0732C30.4702 32.0732 30.8513 31.6922 30.8513 31.2221C30.8513 30.7521 30.4702 30.3711 30.0002 30.3711C29.5302 30.3711 29.1492 30.7521 29.1492 31.2221C29.1492 31.6922 29.5302 32.0732 30.0002 32.0732Z",
    stroke: "#3070CC",
    strokeWidth: 5.95733,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_156_4153",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_156_4153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_156_4153",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyPentugramHouse);
export default __webpack_public_path__ + "static/media/why-pentugram-house.66aeddf0909df9c7cbc0ed32efae9ad0.svg";
export { ForwardRef as ReactComponent };